module.exports = __webpack_public_path__ + "img/20200512_161807.b07fdce3.jpg";